const dev = ['development', 'test'].includes(process.env.NODE_ENV);

const host = window.location.origin + '/';
export const API_BASE = host + 'api/';
